import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "./editProfile.css";

const EditProfileForm = ({ user, onSubmit, onCancel, isSubmitting }) => {
  const [formData, setFormData] = useState({
    name: "",
    country: "",
    city: "",
    address: "",
    mobile_number: "",
  });

  // 🔥 THIS FIXES THE ISSUE
  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        country: user.country || "",
        city: user.city || "",
        address: user.address || "",
        mobile_number: user.mobile_number || "",
      });
    }
  }, [user]);


  const [errors, setErrors] = useState({});

  const handleValidation = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.country.trim()) newErrors.country = "Country is required.";
    if (!formData.city.trim()) newErrors.city = "City is required.";

    // Validate phone number: only digits, +, (), and - are allowed and length between 10 and 15
    const phoneRegex = /^[0-9+() -]{10,15}$/;
    if (!formData.mobile_number.trim()) {
      newErrors.mobile_number = "Phone number is required.";
    } else if (!phoneRegex.test(formData.mobile_number)) {
      newErrors.mobile_number = "Enter a valid phone number (10-15 digits).";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    onSubmit(formData); // Pass valid data to parent component
  };

  return (
    <Form onSubmit={handleSubmit} className="pt-4">
      <Row>
        {/* Name */}
        <Col lg={4} md={6}>
          <Form.Group controlId="name" className="my-1">
            <Form.Label>
              Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              isInvalid={!!errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Email (Disabled) */}
        <Col lg={4} md={6}>
          <Form.Group controlId="email" className="my-1">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={user?.email || ""} disabled />
          </Form.Group>
        </Col>

        {/* Country */}
        <Col lg={4} md={6}>
          <Form.Group controlId="country" className="my-1">
            <Form.Label>
              Country <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter country"
              value={formData.country}
              onChange={(e) =>
                setFormData({ ...formData, country: e.target.value })
              }
              isInvalid={!!errors.country}
            />
            <Form.Control.Feedback type="invalid">
              {errors.country}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* City */}
        <Col lg={4} md={6}>
          <Form.Group controlId="city" className="my-1">
            <Form.Label>
              City <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter city"
              value={formData.city}
              onChange={(e) =>
                setFormData({ ...formData, city: e.target.value })
              }
              isInvalid={!!errors.city}
            />
            <Form.Control.Feedback type="invalid">
              {errors.city}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        {/* Address */}
        <Col lg={4} md={6}>
          <Form.Group controlId="address" className="my-1">
            <Form.Label>Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter address"
              value={formData.address}
              onChange={(e) =>
                setFormData({ ...formData, address: e.target.value })
              }
            />
          </Form.Group>
        </Col>

        {/* Phone */}
        <Col lg={4} md={6}>
          <Form.Group controlId="phone" className="my-1">
            <Form.Label>Phone</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter phone"
              value={formData.mobile_number}
              onChange={(e) => {
                const validValue = e.target.value.replace(/[^0-9+() -]/g, ""); // Allow only numbers, +, (), and -
                setFormData({ ...formData, mobile_number: validValue });
              }}
              isInvalid={!!errors.mobile_number}
            />
            <Form.Control.Feedback type="invalid">
              {errors.mobile_number}
            </Form.Control.Feedback>
          </Form.Group>
          
        </Col>
      </Row>

      {/* Buttons */}
      <Form.Group className="text-end mt-4">
        <Button
          variant="outline-success"
          className="cancel-button mx-2"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button type="submit" className="button">
          Submit
        </Button>
      </Form.Group>
    </Form>
  );
};

export default EditProfileForm;
